// extracted by mini-css-extract-plugin
export var chatbotContainer = "ChatBot-module--chatbot-container--30cf9";
export var loginPrompt = "ChatBot-module--login-prompt--cdfce";
export var sierra = "ChatBot-module--sierra--f68b0";